import axios from 'axios';

class ToggleCheck {
    toggleName: string;
    authorized: boolean;
}
export default class FeatureToggleService {
   
   static checkedToggles: ToggleCheck[] = [];
 
   static checkFeatureToggle = async (toggleName: string, defaultValue: boolean=false) => {
       let localValue = FeatureToggleService.getCachedToggleChecks(toggleName);

       if (localValue) {
           return Promise.resolve(localValue.authorized);
       }
   
        const response = await axios.get<boolean>("FeatureToggle/CheckFeatureToggle", { params: { toggleName, defaultValue } });
        FeatureToggleService.cacheToggle(toggleName, response.data);
        return response.data;
    }
  
    private static getCachedToggleChecks = (toggleName: string): ToggleCheck => {
        return FeatureToggleService.checkedToggles.find((item) => item.toggleName === toggleName);
    }

    private static cacheToggle = (toggleName: string, authorized: boolean): ToggleCheck => {
       let oldAuth = FeatureToggleService.getCachedToggleChecks(toggleName);

        if (oldAuth) {
            FeatureToggleService.checkedToggles.slice(FeatureToggleService.checkedToggles.indexOf(oldAuth), 1);
        }

        let newAuth = {
            toggleName: toggleName,
            authorized: authorized
        };

        FeatureToggleService.checkedToggles.push(newAuth);

        return newAuth;
    }
}